import { InternalCorrectionEntity } from "domain/entity/InternalCorrection/InternalCorrectionEntity";
import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { axiosGetData, axiosPostData, axiosPutData } from "../axios/AxiosBasicImpl";
import referenceAxiosInstance from "../axios/referenceAxiosInstance";
import { InternalCorrectionRepository } from "./InternalCorrectionRepo";

/**
 * For template
 * @returns 
 */
export const InternalCorrectionRepoImpl = (): InternalCorrectionRepository => {
    const url = '/v1/internalCorrection';

    const getEntities = async() : Promise<InternalCorrectionEntity[]> => {
        return await axiosGetData(referenceAxiosInstance, url, []).then(res => {
            return res.data
        }).catch(err => {
            return [];
        });
    }

    const createEntity = async(newData: InternalCorrectionEntity) : Promise<ResponseEntity> => {
        return await axiosPostData(referenceAxiosInstance, `${url}`, newData);
    }

    const updateEntity = async(updatedData: InternalCorrectionEntity): Promise<ResponseEntity> => {
        return await axiosPutData(referenceAxiosInstance, `${url}`, updatedData);
    }

    return {
        getEntities: getEntities,
        createEntity: createEntity,
        updateEntity: updateEntity,
    }
}